import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { GOALS } from '@/widgets/Goals';
import { Button } from '@salutejs/sdds-insol';
import { useModalStore } from '@/entities/Modal';
import { Typography } from '@/shared/ui/Typography';
import { useResize } from '@/shared/lib/hooks/useResize/useResize';
import { GoalItem } from './GoalItem';
import { SelectedGoalParams } from '../../GoalModal';
import cls from './GoalsList.module.scss';

const StyledButton = styled(Button)`
    background-color: #333f48;
`;

type Props = {
    onChangeModalParams: (params: SelectedGoalParams) => void;
};

export const GoalsList = ({ onChangeModalParams }: Props) => {
    const { setIsGoalModalOpen } = useModalStore();

    const containerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const container = containerRef.current;

        if (!container) return;

        const handleWheel = (e: WheelEvent) => {
            if (e.deltaY === 0) return;
            e.preventDefault();
            container.scrollLeft += e.deltaY + e.deltaX;
        };

        container.addEventListener('wheel', handleWheel, { passive: false });

        return () => {
            container.removeEventListener('wheel', handleWheel);
        };
    }, []);

    const width = useResize();
    const buttonSize = width >= 768 ? 'xl' : 'm';

    return (
        <article className={cls.container}>
            <Typography className={cls.title} as="h6" variant="h6_bold">
                Выберите цель или настройте сами
            </Typography>
            <div className={cls.list} ref={containerRef}>
                {GOALS.map((goal) => {
                    const { image, title, id, roomsCount, squareMeters } = goal;

                    return (
                        <GoalItem
                            key={id}
                            image={image}
                            title={title}
                            onClick={() => {
                                onChangeModalParams({
                                    initialRoomsCount: roomsCount,
                                    initialSquareMeters: squareMeters,
                                });
                            }}
                        />
                    );
                })}
            </div>
            <StyledButton
                className={cls.button}
                view="dark"
                size={buttonSize}
                stretch
                onClick={() => {
                    setIsGoalModalOpen(true);
                }}
            >
                <span className="SBSansText">Настроить цель</span>
            </StyledButton>
        </article>
    );
};
